import { formatCurrency, formatNumber, formatPercent } from '@/utils/number';
import dateUtil from '@/utils/date';

/**
 * This object is assigned to Vue prototype as $format, so it's more convenient to format data in template
 * e.g. in tables headers
 */

export default {
    currency: formatCurrency,

    number: formatNumber,

    percent: formatPercent,

    seconds: dateUtil.secondsToString,

    hour: dateUtil.formatHour,

    month: dateUtil.formatMonth,

    date: dateUtil.formatDate,

    datetime: dateUtil.formatDateTime,

    dateForUrl: dateUtil.formatDateForUrl,

    duration: dateUtil.getDurationBetweenDates,

    dateAndHour(value, dateFormat = 'dd.MM.yyyy', timeFormat = 'HH:mm') {
        return `${dateUtil.formatDate(value, dateFormat)} ${dateUtil.formatHour(value, timeFormat)}`;
    },

    param(value) {
        return value && decodeURIComponent(value);
    },
};
